import { render, staticRenderFns } from "./HidePanels.vue?vue&type=template&id=1b42fd4a&"
import script from "./HidePanels.vue?vue&type=script&lang=js&"
export * from "./HidePanels.vue?vue&type=script&lang=js&"
import style0 from "./HidePanels.vue?vue&type=style&index=0&id=1b42fd4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports